import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { propArrayShape, propBool, propFunc, propNumber, } from '../../../../helpers/custom-prop-types';
import ConsultantSearchSolutionSlider from '../../../Ui/ConsultantSearch/Slider/ConsultantSearchSolutionSlider';
import StudyCaseCardNav from './StudyCaseCardNav';
const StudyCaseCard = (props) => {
    const { active, isLg, isMd, isPre, loadStudyCase, showPreModal, solutionLoading, solutions, tags, } = props;
    if (!tags.length) {
        return null;
    }
    return (_jsxs(_Fragment, { children: [_jsx(StudyCaseCardNav, { active: active, loadStudyCase: loadStudyCase, tags: tags }), _jsx(ConsultantSearchSolutionSlider, { isLg: isLg, isMd: isMd, isPre: isPre, showPreModal: showPreModal, solutionLoading: solutionLoading, solutions: solutions })] }));
};
StudyCaseCard.propTypes = {
    active: propNumber().isRequired,
    isLg: propBool().isRequired,
    isMd: propBool().isRequired,
    isPre: propBool().isRequired,
    loadStudyCase: propFunc().isRequired,
    showPreModal: propFunc().isRequired,
    solutionLoading: propBool().isRequired,
    solutions: propArrayShape().isRequired,
    tags: propArrayShape().isRequired,
};
export default StudyCaseCard;
